export default {
  contactSupport: 'Contact Support',
};
